import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/breedlogic-frontend-api/breedlogic-frontend-api/deploy-artifact/src/components/registry/RegistryLandingSection.tsx");
